import { deleteCookie } from '@cian/utils/lib/browser/cookie';
import { parseCookies } from '@cian/utils/lib/shared/cookie';

/**
 * Сессионная кука, по которой выдача понимает, что пользователь пришёл с карточки объявления.
 * Ставит её карточка, а выдача читает и сразу удаляет — так печатная машинка гасится ровно один
 * раз: при обновлении страницы или в новой сессии перебор интентов снова работает.
 */
const DISABLE_PLACEHOLDER_COOKIE = 'disablePlaceholder';

export function readAndRemoveDisablePlaceholderCookie(): boolean {
  if (typeof document === 'undefined') {
    return false;
  }

  const isSet = Boolean(parseCookies(document.cookie)[DISABLE_PLACEHOLDER_COOKIE]);

  if (isSet) {
    deleteCookie(DISABLE_PLACEHOLDER_COOKIE);
  }

  return isSet;
}
